const STRIPE_US_PUBLIC_KEY_TEST = 'pk_test_qqcO2x8EE9CInVN6F5jeRu37'
const STRIPE_US_PUBLIC_KEY_LIVE = 'pk_live_MsSUg9p9WKaP2p2fLEyzYBbw'
const STRIPE_EU_PUBLIC_KEY_TEST = 'pk_test_ehscHPn4tqe4Q0FSPQvGEHCf'
const STRIPE_EU_PUBLIC_KEY_LIVE = 'pk_live_rbmU603WMsK3e9gnHIxD03eY'
const STRIPE_AU_PUBLIC_KEY_TEST = 'pk_test_51INuczKl72gFgJvRiZqDG8CbaBH8cNDzSsb14Bu0Prr802Um6nKflm1yAfMVYJxoBvLrKWJmjEwUSNmUlCzfcCEP00BVYSoY4p'
const STRIPE_AU_PUBLIC_KEY_LIVE = 'pk_live_51INuczKl72gFgJvRYt1dr0voIJMKIYpJZnGqxtj6f1rBiCIH03Is9zlE04qUekKIpqogogEpm4s61BOWrk86cBpG00Bfh5n1Ih'

export function getStripePublicKey(region, isLive) {
  switch (region) {
    case 'US':
      return isLive ? STRIPE_US_PUBLIC_KEY_LIVE : STRIPE_US_PUBLIC_KEY_TEST
    case 'EU':
      return isLive ? STRIPE_EU_PUBLIC_KEY_LIVE : STRIPE_EU_PUBLIC_KEY_TEST
    case 'AU':
      return isLive ? STRIPE_AU_PUBLIC_KEY_LIVE : STRIPE_AU_PUBLIC_KEY_TEST
    default:
      return null
  }
}

export function getRegionForCurrency(currency) {
  switch (currency) {
    case 'USD':
      return 'US'
    case 'EUR':
      return 'EU'
    case 'AUD':
      return 'AU'
    default:
      return 'US'
  }
}
